<script setup lang="ts">
import HistoryInfo from './HistoryInfo.vue'
</script>

<template>
  <HistoryInfo
    title="There are no incidents yet"
    icon="inbox"
    description="They will appear here when a scout records an incident in match"
  />
</template>
